"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITE_LINKS = exports.MAX_COLUMNS = void 0;
const SITE_LINKS = exports.SITE_LINKS = 'site-links';
const MAX_COLUMNS = exports.MAX_COLUMNS = 3;